const CONSTANTS = {
	REDUX_ACTION: {
		REDUX_PRESIST: "REDUX_PRESIST",
	},
	DISPLAY_ADS: "DISPLAY_ADS",
};

export default CONSTANTS;
